import en from './remoteMessages.en';

const pl = {
    title: 'Zdalny podgląd',
    description: 'Korzystaj z tego odtwarzacza i kolejki jak dotychczas. Połączony tablet wyświetla wybrane przez Ciebie filmy.',
    statusIdle: 'Brak połączenia',
    statusPreparing: 'Przygotowywanie linku…',
    statusWaiting: 'Oczekiwanie na ekran podglądu',
    statusConnecting: 'Łączenie…',
    statusConnected: 'Ekran połączony',
    connect: 'Połącz ekran podglądu',
    newLink: 'Utwórz nowy link',
    disconnect: 'Rozłącz',
    qrLabel: 'Kod QR do połączenia ekranu podglądu',
    qrCaption: 'Zeskanuj aparatem tabletu',
    qrInstructions: 'Zeskanuj kod QR aparatem tabletu, aby otworzyć ekran podglądu. Użyj tej samej sieci Wi-Fi, aby połączyć urządzenia bezpośrednio. W razie potrzeby połączenie przez serwer zostanie uruchomione automatycznie.',
    qrExpiry: 'Kod wygasa po 10 minutach i pozwala połączyć jeden ekran. Po połączeniu dotknij przycisku „Rozpocznij sesję” na tablecie.',
    linkLabel: 'Możesz też otworzyć ten link na tablecie:',
    copyLink: 'Kopiuj link',
    copySuccess: 'Link skopiowany',
    copyManual: 'Zaznacz link powyżej i skopiuj go na tablet.',
    connectionDirect: 'Połączenie: bezpośrednie',
    connectionServer: 'Połączenie: przez serwer',
    viewerReady: 'Ekran podglądu jest gotowy.',
    viewerPlaying: 'Film jest odtwarzany na ekranie podglądu.',
    viewerPaused: 'Odtwarzanie na ekranie podglądu jest wstrzymane.',
    viewerWaiting: 'Oczekiwanie na uruchomienie ekranu podglądu.',
    viewerBlocked: 'Dotknij przycisku „Rozpocznij sesję” na ekranie podglądu, aby zezwolić na odtwarzanie.',
    viewerVideoError: 'Nie udało się wczytać tego filmu na ekranie podglądu.',
    connectingServer: 'Łączenie przez serwer…',
    controllerDisconnected: 'Ekran podglądu został rozłączony. Utwórz nowy link, aby połączyć go ponownie.',
    linkExpired: 'Link do parowania wygasł. Utwórz nowy link w panelu sterowania i spróbuj ponownie.',
    viewerTitle: 'Ekran podglądu Teddy',
    viewerScreenLabel: 'Ekran podglądu Teddy',
    viewerConnecting: 'Łączenie z odtwarzaczem terapeuty…',
    viewerConnected: 'Połączono. Terapeuta steruje filmami.',
    viewerStart: 'Rozpocznij sesję',
    viewerHint: 'Pozostaw ten ekran otwarty. Dotknij filmu dwukrotnie, aby ponownie włączyć pełny ekran.',
    viewerDisconnected: 'Panel sterowania został rozłączony. Poproś terapeutę o utworzenie nowego linku do parowania.',
    viewerLost: 'Utracono połączenie. Poproś terapeutę o utworzenie nowego linku do parowania.',
    viewerMissingLink: 'Otwórz link do parowania z panelu „Zdalny podgląd” u terapeuty.',
    viewerLinkNotReady: 'Ten link nie jest gotowy. Poproś terapeutę o nowy link.',
    viewerTimeout: 'Nie udało się połączyć z odtwarzaczem terapeuty. Pozostaw go otwarty i poproś o nowy link do parowania.',
    errorConnection: 'Nie udało się połączyć ekranu podglądu. Spróbuj ponownie.',
    errorSameWebsite: 'Połącz oba urządzenia, korzystając z tej samej strony internetowej.',
    errorMessageTooLarge: 'Komunikat połączenia jest zbyt duży. Utwórz nowy link do parowania.',
    errorInvalidOffer: 'Nie udało się przygotować połączenia. Utwórz nowy link do parowania.',
    errorBusy: 'Trwa inne parowanie. Spróbuj ponownie za chwilę.',
    errorCredentials: 'Ten link do parowania jest nieprawidłowy. Poproś terapeutę o nowy link.',
    errorLinkUsed: 'Ten link został już użyty. Utwórz nowy link.',
    errorOperation: 'Nie udało się dokończyć parowania. Utwórz nowy link.',
    errorAnswer: 'Nie udało się nawiązać połączenia. Utwórz nowy link do parowania.',
    errorSessionEnded: 'Ta sesja została zakończona. Poproś terapeutę o nowy link do parowania.',
    errorPlayback: 'Nie udało się zsynchronizować odtwarzania. Utwórz nowy link do parowania.',
    errorServerTimeout: 'Upłynął czas oczekiwania na połączenie przez serwer. Spróbuj ponownie.',
    errorUnsupportedBrowser: 'Ta przeglądarka nie obsługuje zdalnego podglądu.',
    errorNoCandidate: 'Nie znaleziono adresu do połączenia bezpośredniego.',
};

const it = {
    title: 'Visualizzazione remota',
    description: 'Continua a usare questo lettore e la coda dei video. Il tablet associato riproduce i video che scegli.',
    statusIdle: 'Non connesso',
    statusPreparing: 'Preparazione del link…',
    statusWaiting: 'In attesa dello schermo remoto',
    statusConnecting: 'Connessione in corso…',
    statusConnected: 'Schermo connesso',
    connect: 'Collega lo schermo remoto',
    newLink: 'Crea un nuovo link',
    disconnect: 'Disconnetti',
    qrLabel: 'Codice QR per collegare lo schermo remoto',
    qrCaption: 'Scansiona con la fotocamera del tablet',
    qrInstructions: 'Scansiona il codice QR con la fotocamera del tablet per aprire lo schermo remoto. Usa la stessa rete Wi-Fi per una connessione diretta; se necessario, la connessione tramite server si attiva automaticamente.',
    qrExpiry: 'Questo codice scade tra 10 minuti e consente di associare un solo schermo. Dopo la connessione, tocca «Avvia sessione» sul tablet.',
    linkLabel: 'Oppure apri questo link sul tablet:',
    copyLink: 'Copia link',
    copySuccess: 'Link copiato',
    copyManual: 'Seleziona il link qui sopra e copialo sul tablet.',
    connectionDirect: 'Connessione: diretta',
    connectionServer: 'Connessione: tramite server',
    viewerReady: 'Lo schermo remoto è pronto.',
    viewerPlaying: 'Il video è in riproduzione sullo schermo remoto.',
    viewerPaused: 'La riproduzione sullo schermo remoto è in pausa.',
    viewerWaiting: 'In attesa che lo schermo remoto venga avviato.',
    viewerBlocked: 'Tocca «Avvia sessione» sullo schermo remoto per consentire la riproduzione.',
    viewerVideoError: 'Non è stato possibile caricare questo video sullo schermo remoto.',
    connectingServer: 'Connessione tramite server in corso…',
    controllerDisconnected: 'Lo schermo remoto si è disconnesso. Crea un nuovo link per ricollegarlo.',
    linkExpired: 'Il link di associazione è scaduto. Crea un nuovo link nel pannello di controllo per riprovare.',
    viewerTitle: 'Schermo remoto Teddy',
    viewerScreenLabel: 'Schermo remoto Teddy',
    viewerConnecting: 'Connessione al lettore del terapista…',
    viewerConnected: 'Connessione riuscita. Il terapista controlla i video.',
    viewerStart: 'Avvia sessione',
    viewerHint: 'Lascia aperta questa schermata. Tocca due volte il video per tornare a schermo intero.',
    viewerDisconnected: 'Il pannello di controllo si è disconnesso. Chiedi al terapista di creare un nuovo link di associazione.',
    viewerLost: 'Connessione persa. Chiedi al terapista di creare un nuovo link di associazione.',
    viewerMissingLink: 'Apri un link di associazione dal pannello «Visualizzazione remota» del terapista.',
    viewerLinkNotReady: 'Questo link non è pronto. Chiedi al terapista un nuovo link.',
    viewerTimeout: 'Non è stato possibile raggiungere il lettore del terapista. Lascialo aperto e chiedi un nuovo link di associazione.',
    errorConnection: 'Non è stato possibile collegare lo schermo remoto. Riprova.',
    errorSameWebsite: 'Associa entrambi i dispositivi usando lo stesso sito web.',
    errorMessageTooLarge: 'Il messaggio di connessione è troppo grande. Crea un nuovo link di associazione.',
    errorInvalidOffer: 'Non è stato possibile preparare la connessione. Crea un nuovo link di associazione.',
    errorBusy: 'È in corso un’altra associazione. Riprova tra poco.',
    errorCredentials: 'Questo link di associazione non è valido. Chiedi al terapista un nuovo link.',
    errorLinkUsed: 'Questo link è già stato utilizzato. Crea un nuovo link.',
    errorOperation: 'Non è stato possibile completare l’associazione. Crea un nuovo link.',
    errorAnswer: 'Non è stato possibile completare la connessione. Crea un nuovo link di associazione.',
    errorSessionEnded: 'Questa sessione è terminata. Chiedi al terapista un nuovo link di associazione.',
    errorPlayback: 'Non è stato possibile sincronizzare la riproduzione. Crea un nuovo link di associazione.',
    errorServerTimeout: 'Il tempo di attesa per la connessione tramite server è scaduto. Riprova.',
    errorUnsupportedBrowser: 'Questo browser non supporta la visualizzazione remota.',
    errorNoCandidate: 'Non è stato trovato alcun indirizzo per la connessione diretta.',
};

const es = {
    title: 'Visualización remota',
    description: 'Sigue usando este reproductor y la cola de vídeos. La tableta vinculada reproduce los vídeos que eliges.',
    statusIdle: 'Sin conexión',
    statusPreparing: 'Preparando enlace…',
    statusWaiting: 'Esperando a la pantalla remota',
    statusConnecting: 'Conectando…',
    statusConnected: 'Pantalla conectada',
    connect: 'Conectar pantalla remota',
    newLink: 'Crear nuevo enlace',
    disconnect: 'Desconectar',
    qrLabel: 'Código QR para conectar la pantalla remota',
    qrCaption: 'Escanea con la cámara de la tableta',
    qrInstructions: 'Escanea el código QR con la cámara de la tableta para abrir la pantalla remota. Usa la misma red Wi-Fi para una conexión directa; si es necesario, se activa automáticamente una conexión a través del servidor.',
    qrExpiry: 'Este código caduca en 10 minutos y permite vincular una sola pantalla. Tras conectarla, toca «Comenzar sesión» en la tableta.',
    linkLabel: 'O abre este enlace en la tableta:',
    copyLink: 'Copiar enlace',
    copySuccess: 'Enlace copiado',
    copyManual: 'Selecciona el enlace de arriba y cópialo en la tableta.',
    connectionDirect: 'Conexión: directa',
    connectionServer: 'Conexión: a través del servidor',
    viewerReady: 'La pantalla remota está lista.',
    viewerPlaying: 'El vídeo se está reproduciendo en la pantalla remota.',
    viewerPaused: 'La reproducción en la pantalla remota está en pausa.',
    viewerWaiting: 'Esperando a que se inicie la pantalla remota.',
    viewerBlocked: 'Toca «Comenzar sesión» en la pantalla remota para permitir la reproducción.',
    viewerVideoError: 'No se ha podido cargar este vídeo en la pantalla remota.',
    connectingServer: 'Conectando a través del servidor…',
    controllerDisconnected: 'La pantalla remota se ha desconectado. Crea un nuevo enlace para volver a conectarla.',
    linkExpired: 'El enlace de vinculación ha caducado. Crea un nuevo enlace en el panel de control para volver a intentarlo.',
    viewerTitle: 'Pantalla remota de Teddy',
    viewerScreenLabel: 'Pantalla remota de Teddy',
    viewerConnecting: 'Conectando con el reproductor del terapeuta…',
    viewerConnected: 'Conexión establecida. El terapeuta controla los vídeos.',
    viewerStart: 'Comenzar sesión',
    viewerHint: 'Mantén esta pantalla abierta. Toca dos veces el vídeo para volver a la pantalla completa.',
    viewerDisconnected: 'El panel de control se ha desconectado. Pide al terapeuta que cree un nuevo enlace de vinculación.',
    viewerLost: 'Se ha perdido la conexión. Pide al terapeuta que cree un nuevo enlace de vinculación.',
    viewerMissingLink: 'Abre un enlace de vinculación desde el panel «Visualización remota» del terapeuta.',
    viewerLinkNotReady: 'Este enlace no está listo. Pide al terapeuta un nuevo enlace.',
    viewerTimeout: 'No se ha podido conectar con el reproductor del terapeuta. Mantenlo abierto y pide un nuevo enlace de vinculación.',
    errorConnection: 'No se ha podido conectar la pantalla remota. Vuelve a intentarlo.',
    errorSameWebsite: 'Vincula ambos dispositivos usando el mismo sitio web.',
    errorMessageTooLarge: 'El mensaje de conexión es demasiado grande. Crea un nuevo enlace de vinculación.',
    errorInvalidOffer: 'No se ha podido preparar la conexión. Crea un nuevo enlace de vinculación.',
    errorBusy: 'Hay otra vinculación en curso. Vuelve a intentarlo en unos instantes.',
    errorCredentials: 'Este enlace de vinculación no es válido. Pide al terapeuta un nuevo enlace.',
    errorLinkUsed: 'Este enlace ya se ha utilizado. Crea un nuevo enlace.',
    errorOperation: 'No se ha podido completar la vinculación. Crea un nuevo enlace.',
    errorAnswer: 'No se ha podido completar la conexión. Crea un nuevo enlace de vinculación.',
    errorSessionEnded: 'Esta sesión ha terminado. Pide al terapeuta un nuevo enlace de vinculación.',
    errorPlayback: 'No se ha podido sincronizar la reproducción. Crea un nuevo enlace de vinculación.',
    errorServerTimeout: 'Se ha agotado el tiempo de espera de la conexión a través del servidor. Vuelve a intentarlo.',
    errorUnsupportedBrowser: 'Este navegador no admite la visualización remota.',
    errorNoCandidate: 'No se ha encontrado ninguna dirección para la conexión directa.',
};

const el = {
    title: 'Απομακρυσμένη προβολή',
    description: 'Συνεχίστε να χρησιμοποιείτε αυτό το πρόγραμμα αναπαραγωγής και τη λίστα βίντεο. Το συνδεδεμένο τάμπλετ προβάλλει τα βίντεο που επιλέγετε.',
    statusIdle: 'Χωρίς σύνδεση',
    statusPreparing: 'Προετοιμασία συνδέσμου…',
    statusWaiting: 'Αναμονή για την οθόνη προβολής',
    statusConnecting: 'Σύνδεση…',
    statusConnected: 'Η οθόνη συνδέθηκε',
    connect: 'Σύνδεση οθόνης προβολής',
    newLink: 'Δημιουργία νέου συνδέσμου',
    disconnect: 'Αποσύνδεση',
    qrLabel: 'Κωδικός QR για τη σύνδεση της οθόνης προβολής',
    qrCaption: 'Σαρώστε με την κάμερα του τάμπλετ',
    qrInstructions: 'Σαρώστε τον κωδικό QR με την κάμερα του τάμπλετ για να ανοίξετε την οθόνη προβολής. Χρησιμοποιήστε το ίδιο δίκτυο Wi-Fi για απευθείας σύνδεση. Αν χρειαστεί, η σύνδεση μέσω διακομιστή ενεργοποιείται αυτόματα.',
    qrExpiry: 'Αυτός ο κωδικός λήγει σε 10 λεπτά και συνδέει μία μόνο οθόνη. Μετά τη σύνδεση, πατήστε «Έναρξη συνεδρίας» στο τάμπλετ.',
    linkLabel: 'Ή ανοίξτε αυτόν τον σύνδεσμο στο τάμπλετ:',
    copyLink: 'Αντιγραφή συνδέσμου',
    copySuccess: 'Ο σύνδεσμος αντιγράφηκε',
    copyManual: 'Επιλέξτε τον παραπάνω σύνδεσμο και αντιγράψτε τον στο τάμπλετ.',
    connectionDirect: 'Σύνδεση: απευθείας',
    connectionServer: 'Σύνδεση: μέσω διακομιστή',
    viewerReady: 'Η οθόνη προβολής είναι έτοιμη.',
    viewerPlaying: 'Το βίντεο αναπαράγεται στην οθόνη προβολής.',
    viewerPaused: 'Η αναπαραγωγή στην οθόνη προβολής έχει τεθεί σε παύση.',
    viewerWaiting: 'Αναμονή για την έναρξη της οθόνης προβολής.',
    viewerBlocked: 'Πατήστε «Έναρξη συνεδρίας» στην οθόνη προβολής για να επιτρέψετε την αναπαραγωγή.',
    viewerVideoError: 'Δεν ήταν δυνατή η φόρτωση αυτού του βίντεο στην οθόνη προβολής.',
    connectingServer: 'Σύνδεση μέσω διακομιστή…',
    controllerDisconnected: 'Η οθόνη προβολής αποσυνδέθηκε. Δημιουργήστε νέο σύνδεσμο για επανασύνδεση.',
    linkExpired: 'Ο σύνδεσμος σύζευξης έληξε. Δημιουργήστε νέο σύνδεσμο στον πίνακα ελέγχου για να δοκιμάσετε ξανά.',
    viewerTitle: 'Οθόνη προβολής Teddy',
    viewerScreenLabel: 'Οθόνη προβολής Teddy',
    viewerConnecting: 'Σύνδεση στο πρόγραμμα αναπαραγωγής του θεραπευτή…',
    viewerConnected: 'Η σύνδεση ολοκληρώθηκε. Ο θεραπευτής ελέγχει τα βίντεο.',
    viewerStart: 'Έναρξη συνεδρίας',
    viewerHint: 'Κρατήστε αυτή την οθόνη ανοιχτή. Πατήστε δύο φορές το βίντεο για να επιστρέψετε σε πλήρη οθόνη.',
    viewerDisconnected: 'Ο πίνακας ελέγχου αποσυνδέθηκε. Ζητήστε από τον θεραπευτή να δημιουργήσει νέο σύνδεσμο σύζευξης.',
    viewerLost: 'Η σύνδεση χάθηκε. Ζητήστε από τον θεραπευτή να δημιουργήσει νέο σύνδεσμο σύζευξης.',
    viewerMissingLink: 'Ανοίξτε έναν σύνδεσμο σύζευξης από τον πίνακα «Απομακρυσμένη προβολή» του θεραπευτή.',
    viewerLinkNotReady: 'Αυτός ο σύνδεσμος δεν είναι έτοιμος. Ζητήστε νέο σύνδεσμο από τον θεραπευτή.',
    viewerTimeout: 'Δεν ήταν δυνατή η σύνδεση στο πρόγραμμα αναπαραγωγής του θεραπευτή. Κρατήστε το ανοιχτό και ζητήστε νέο σύνδεσμο σύζευξης.',
    errorConnection: 'Δεν ήταν δυνατή η σύνδεση της οθόνης προβολής. Δοκιμάστε ξανά.',
    errorSameWebsite: 'Συνδέστε και τις δύο συσκευές χρησιμοποιώντας τον ίδιο ιστότοπο.',
    errorMessageTooLarge: 'Το μήνυμα σύνδεσης είναι πολύ μεγάλο. Δημιουργήστε νέο σύνδεσμο σύζευξης.',
    errorInvalidOffer: 'Δεν ήταν δυνατή η προετοιμασία της σύνδεσης. Δημιουργήστε νέο σύνδεσμο σύζευξης.',
    errorBusy: 'Μια άλλη σύζευξη βρίσκεται σε εξέλιξη. Δοκιμάστε ξανά σε λίγο.',
    errorCredentials: 'Αυτός ο σύνδεσμος σύζευξης δεν είναι έγκυρος. Ζητήστε νέο σύνδεσμο από τον θεραπευτή.',
    errorLinkUsed: 'Αυτός ο σύνδεσμος έχει ήδη χρησιμοποιηθεί. Δημιουργήστε νέο σύνδεσμο.',
    errorOperation: 'Δεν ήταν δυνατή η ολοκλήρωση της σύζευξης. Δημιουργήστε νέο σύνδεσμο.',
    errorAnswer: 'Δεν ήταν δυνατή η ολοκλήρωση της σύνδεσης. Δημιουργήστε νέο σύνδεσμο σύζευξης.',
    errorSessionEnded: 'Αυτή η συνεδρία ολοκληρώθηκε. Ζητήστε νέο σύνδεσμο σύζευξης από τον θεραπευτή.',
    errorPlayback: 'Δεν ήταν δυνατός ο συγχρονισμός της αναπαραγωγής. Δημιουργήστε νέο σύνδεσμο σύζευξης.',
    errorServerTimeout: 'Ο χρόνος αναμονής για τη σύνδεση μέσω διακομιστή έληξε. Δοκιμάστε ξανά.',
    errorUnsupportedBrowser: 'Αυτό το πρόγραμμα περιήγησης δεν υποστηρίζει απομακρυσμένη προβολή.',
    errorNoCandidate: 'Δεν βρέθηκε διεύθυνση για απευθείας σύνδεση.',
};

const lt = {
    title: 'Nuotolinė peržiūra',
    description: 'Toliau naudokite šį grotuvą ir vaizdo įrašų eilę. Susieta planšetė rodo jūsų pasirinktus vaizdo įrašus.',
    statusIdle: 'Neprisijungta',
    statusPreparing: 'Ruošiama nuoroda…',
    statusWaiting: 'Laukiama peržiūros ekrano',
    statusConnecting: 'Jungiamasi…',
    statusConnected: 'Ekranas prijungtas',
    connect: 'Prijungti peržiūros ekraną',
    newLink: 'Sukurti naują nuorodą',
    disconnect: 'Atjungti',
    qrLabel: 'QR kodas peržiūros ekranui prijungti',
    qrCaption: 'Nuskaitykite planšetės kamera',
    qrInstructions: 'Nuskaitykite QR kodą planšetės kamera, kad atvertumėte peržiūros ekraną. Tiesioginiam ryšiui naudokite tą patį „Wi-Fi“ tinklą. Prireikus automatiškai įjungiamas ryšys per serverį.',
    qrExpiry: 'Šis kodas galioja 10 minučių ir leidžia susieti vieną ekraną. Prisijungę planšetėje palieskite „Pradėti seansą“.',
    linkLabel: 'Arba atverkite šią nuorodą planšetėje:',
    copyLink: 'Kopijuoti nuorodą',
    copySuccess: 'Nuoroda nukopijuota',
    copyManual: 'Pažymėkite aukščiau esančią nuorodą ir nukopijuokite ją į planšetę.',
    connectionDirect: 'Ryšys: tiesioginis',
    connectionServer: 'Ryšys: per serverį',
    viewerReady: 'Peržiūros ekranas paruoštas.',
    viewerPlaying: 'Peržiūros ekrane leidžiamas vaizdo įrašas.',
    viewerPaused: 'Atkūrimas peržiūros ekrane pristabdytas.',
    viewerWaiting: 'Laukiama, kol bus paleistas peržiūros ekranas.',
    viewerBlocked: 'Peržiūros ekrane palieskite „Pradėti seansą“, kad leistumėte atkurti vaizdo įrašus.',
    viewerVideoError: 'Peržiūros ekrane nepavyko įkelti šio vaizdo įrašo.',
    connectingServer: 'Jungiamasi per serverį…',
    controllerDisconnected: 'Peržiūros ekranas atsijungė. Sukurkite naują nuorodą, kad vėl jį prijungtumėte.',
    linkExpired: 'Susiejimo nuorodos galiojimas baigėsi. Valdymo skydelyje sukurkite naują nuorodą ir bandykite dar kartą.',
    viewerTitle: '„Teddy“ peržiūros ekranas',
    viewerScreenLabel: '„Teddy“ peržiūros ekranas',
    viewerConnecting: 'Jungiamasi prie terapeuto grotuvo…',
    viewerConnected: 'Prisijungta. Vaizdo įrašus valdo terapeutas.',
    viewerStart: 'Pradėti seansą',
    viewerHint: 'Palikite šį ekraną atvertą. Dukart palieskite vaizdo įrašą, kad vėl įjungtumėte viso ekrano režimą.',
    viewerDisconnected: 'Valdymo skydelis atsijungė. Paprašykite terapeuto sukurti naują susiejimo nuorodą.',
    viewerLost: 'Ryšys nutrūko. Paprašykite terapeuto sukurti naują susiejimo nuorodą.',
    viewerMissingLink: 'Atverkite susiejimo nuorodą iš terapeuto skydelio „Nuotolinė peržiūra“.',
    viewerLinkNotReady: 'Ši nuoroda neparuošta. Paprašykite terapeuto naujos nuorodos.',
    viewerTimeout: 'Nepavyko prisijungti prie terapeuto grotuvo. Palikite jį atvertą ir paprašykite naujos susiejimo nuorodos.',
    errorConnection: 'Nepavyko prijungti peržiūros ekrano. Bandykite dar kartą.',
    errorSameWebsite: 'Abu įrenginius susiekite naudodami tą pačią svetainę.',
    errorMessageTooLarge: 'Ryšio pranešimas per didelis. Sukurkite naują susiejimo nuorodą.',
    errorInvalidOffer: 'Nepavyko paruošti ryšio. Sukurkite naują susiejimo nuorodą.',
    errorBusy: 'Vyksta kitas susiejimas. Netrukus bandykite dar kartą.',
    errorCredentials: 'Ši susiejimo nuoroda negalioja. Paprašykite terapeuto naujos nuorodos.',
    errorLinkUsed: 'Ši nuoroda jau panaudota. Sukurkite naują nuorodą.',
    errorOperation: 'Nepavyko užbaigti susiejimo. Sukurkite naują nuorodą.',
    errorAnswer: 'Nepavyko užmegzti ryšio. Sukurkite naują susiejimo nuorodą.',
    errorSessionEnded: 'Šis seansas baigėsi. Paprašykite terapeuto naujos susiejimo nuorodos.',
    errorPlayback: 'Nepavyko sinchronizuoti atkūrimo. Sukurkite naują susiejimo nuorodą.',
    errorServerTimeout: 'Baigėsi ryšio per serverį laukimo laikas. Bandykite dar kartą.',
    errorUnsupportedBrowser: 'Ši naršyklė nepalaiko nuotolinės peržiūros.',
    errorNoCandidate: 'Nepavyko rasti tiesioginio ryšio adreso.',
};

const translations = { en, pl, it, es, el, lt };
export default translations;
